module.exports = __webpack_public_path__ + "img/living-icon.3af56577.gif";